import { storePalette } from "../../utils/palette";
import { listenerMiddleware } from "../listenerMiddleware";
import {
  connectionStatusChanged,
  lastSyncRecorded,
  paletteChosen,
  themeChanged
} from "../slices/deviceSlice";

export const registerDeviceListeners = () => {
  listenerMiddleware.startListening({
    actionCreator: themeChanged,
    effect: (action) => {
      const theme = action.payload;
      document.documentElement.classList.add("theme-switching");
      document.body.setAttribute("data-theme", theme);
      if (theme === "Dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
      setTimeout(() => {
        document.documentElement.classList.remove("theme-switching");
      }, 10);
    }
  });

  listenerMiddleware.startListening({
    actionCreator: paletteChosen,
    effect: (action) => {
      void storePalette(action.payload);
    }
  });

  listenerMiddleware.startListening({
    actionCreator: connectionStatusChanged,
    effect: (action, { dispatch }) => {
      if (action.payload !== "internet") {
        dispatch(lastSyncRecorded(new Date().toISOString()));
      }
    }
  });
};
